import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PiErrorInterceptor } from '@app-core/interceptors/pi-error.interceptor';
import { RedirectInterceptor } from '@app-core/interceptors/redirect.interceptor';
import { AppConfigurationProvider } from '@app-core/models/config';

/* eslint-disable @typescript-eslint/no-explicit-any */

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PiErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RedirectInterceptor,
      multi: true
    },
    {
      provide: AppConfigurationProvider,
      useValue: {
        ...(window as any).config,
        relay42_config: {
          preview: false,
          nsenvironment: 'dev',
          language: 'nl',
          ...(window as any).BASE_RELAY_TAG_PROPERTIES
        }
      }
    }
  ]
})
export class CoreModule {}
